import React from 'react';

const IVRLogsRenderer = (props) => {
    const handleClick = () => {
        // Implement the functionality for resending consent
    };

    const buttonHtml = `
        <button 
            style="padding:2% 10% 5% 10%" 
            class="btn1 btn-warning" 
           
            title="Logs"
            onclick="(${handleClick.toString()})()"
        >
            View
        </button>
    `;

    return (
        
        <div dangerouslySetInnerHTML={{ __html: buttonHtml }} />
    );
};

export default IVRLogsRenderer;

